const API_BASE_URL = "https://api.hosilim.uz/api/v1";
export default API_BASE_URL;
